<template>
    <div :style="{ height: height, width: width }">
        <div style="width: 100%;position: relative;height: 100%;" :style="{ zoom: zoom, left: margin_left }">
            <border-rect-item v-for="(item, i) in rooms" :lengthRate="lengthRate" :markVisable="markVisable"
                :markLocationVisable="markLocationVisable" :key="i" :index="i" :data="item" ref="rectItems"
                :boundary="boundary" @rectChange="rectChange">
            </border-rect-item>
            <avue-draggable :width="obj.width" :height="obj.height" :left="obj.left" :top="obj.top" ref="point"
                @blur="chooseEnd" v-if="chooseVisable">
                <div style="background: yellow"></div>
            </avue-draggable>
            <div style="width:100%;height:100%;position:absolute;left:0px;top:0;z-index:999;"></div>
        </div>
    </div>
</template>
<script>
import BorderRectItem from './border-rect-item.vue'
import { commit_rooms } from '../api/options';
export default {
    components: { BorderRectItem },
    name: "DesignerView",
    props: {
        data: Object,
        height: Number,
        width: Number
    },
    data: () => {
        return {
            boundary: {},
            lengthRate: 30,
            markVisable: false,
            markLocationVisable: false,
            rooms: [],
            chooseVisable: false,
            zoom: 0,
            margin_left: "0px"
        }
    },
    mounted() {
        let room_info = JSON.parse(this.data.room_info);
        let rooms = JSON.parse(this.data.data).rooms;
        commit_rooms(rooms, room_info, 0, 0);
        this.rooms = rooms;
        let min_w = 9999, max_w = 0, min_h = 9999, max_h = 0;
        rooms.filter((e) => {
            // if (e.type.indexOf('white_m') >= 0) {
            //     return;
            // }
            if (e.top < min_h)
                min_h = e.top;
            if (e.top + e.height > max_h)
                max_h = e.top + e.height;
            if (e.left < min_w)
                min_w = e.left;
            if (e.width + e.left > max_w)
                max_w = e.width + e.left;
        });
        let rw = max_w - min_w + 20;
        let rh = max_h - min_h + 20;
        let scale = Math.min(this.width / rw, this.height / rh);
        this.zoom = scale;
        this.margin_left = ((this.width - rw * scale) / scale) / 2 + "px";
    },
    methods: {
        rectChange(...p) {
            this.$emit('rectChange', ...p);
        }
    }

}
</script>